import AccountingInfoOption from './AccountingInfoOption';

export default class ControlType extends AccountingInfoOption {
    public static entity = 'controlTypes';
    public static apiType = 'control-types';
    public static storageKey = 'control_types_list';
}